<script setup>
import { defineProps } from 'vue'
import { useMainStore } from '@/stores/main'
import SignalDetail from '@/components/Signals/SignalDetail.vue'

const props = defineProps(["data", "width"])

const mainStore = useMainStore()

function openSignal(sig) {
  mainStore.show_slideover(SignalDetail, { signalId: sig.id }, { width: 50 }, sig.title || 'Signal')
}
</script>

<template>
  <div
    class="signals-cell"
    v-if="props.data && props.data.length > 0"
    :style="props.width ? { maxWidth: props.width + 'px' } : null"
  >
    <span class="signal-title" :title="props.data[0].title" @click.stop="openSignal(props.data[0])">
      {{ props.data[0].title }}
    </span>
    <span v-if="props.data.length > 1" class="text-muted signal-more">
      (+{{ props.data.length - 1 }} more)
    </span>
  </div>
</template>

<style scoped>
.signals-cell {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  min-width: 0;
  max-width: 100%;
}

.signal-title {
  flex: 0 1 auto;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
}

.signal-title:hover {
  text-decoration: underline;
}

.signal-more {
  flex: 0 0 auto;
  white-space: nowrap;
}
</style>
